import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loanworkflow',
  templateUrl: './loanworkflow.component.html',
  styleUrls: ['./loanworkflow.component.css']
})
export class LoanworkflowComponent implements OnInit {

  constructor() { }
  ngOnInit() {

  }

}
